if(!customElements.get('site-video')) {
  class SiteVideo extends HTMLElement {
    constructor() {
      super();
      this.video = null;
    }

    connectedCallback() {
      this.video = this.querySelector("video");
      this.observe();
    }

    observe() {
      if ("IntersectionObserver" in window) {
        const videoObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((video) => {
            const $video = video.target;
            if (video.isIntersecting) {
              if ($video.readyState === 4 && this.dataset.autoplay !== "false") {
                $video.play();
              } else {
                [].slice
                  .call($video.querySelectorAll("source"))
                  .forEach((source) => {
                    source.src = source.dataset.src;
                  });

                $video.load();
              }
            } else {
              if (!$video.paused) {
                $video.pause();
              }
            }
          });
        });

        videoObserver.observe(this.video);
      }
    }

    play() {
      this.video.play();
    }

    pause() {
      this.video.pause();
    }
  }

  customElements.define("site-video", SiteVideo);
}
